import type { Attribution, LeadSubmission, ServiceId } from "@shared/types";

const apiBase = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, "") || "";

export async function recordEvent(type: "visit" | "form_start", attribution: Attribution) {
  if (import.meta.env.DEV) return;
  await fetch(`${apiBase}/api/events`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    keepalive: true,
    body: JSON.stringify({ type, attribution, occurredAt: new Date().toISOString() }),
  });
}

export async function submitLead(input: Omit<LeadSubmission, "idempotencyKey">) {
  const idempotencyKey = crypto.randomUUID();
  if (import.meta.env.DEV) {
    await new Promise((resolve) => setTimeout(resolve, 450));
    return { leadId: `local-${idempotencyKey.slice(0, 8)}`, status: "accepted" as const };
  }
  const response = await fetch(`${apiBase}/api/leads`, {
    method: "POST",
    headers: { "content-type": "application/json", "idempotency-key": idempotencyKey },
    body: JSON.stringify({ ...input, idempotencyKey }),
  });
  if (!response.ok) throw new Error("We couldn’t send your request. Please try again.");
  return (await response.json()) as { leadId: string; status: "accepted" };
}

export const serviceLabels: Record<ServiceId, string> = {
  bokeping: "Bokeping",
  tax: "Tax preparation",
  payroll: "Payroll",
  "partner-service": "Service Network",
  "other-service": "Another professional service",
};
